<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = useRouter()
const auth = useAuthStore()
const identity = ref('')
const password = ref('')

async function submit() {
  try {
    await auth.login(identity.value, password.value)
    await router.push('/chat')
  } catch {
    // Store exposes the user-facing error.
  }
}
</script>

<template>
  <main class="auth-layout">
    <section class="auth-intro">
      <div class="brand light">
        <div class="brand-mark">
          <span class="beta-symbol" aria-label="beta hat">β</span>
        </div>
        <div>
          <strong>计量客栈</strong>
          <span>Econometrics Inn</span>
          <small class="brand-author">by SKY Labs</small>
        </div>
      </div>
      <div class="intro-copy">
        <h1>
          <span>让厚重的经典计量教材，</span>
          <span>成为你的随身口袋书。</span>
        </h1>
        <p class="eyebrow intro-tagline">从直觉到识别，从公式到实证</p>
      </div>
    </section>

    <section class="auth-panel">
      <form class="auth-form" @submit.prevent="submit">
        <p class="eyebrow">欢迎回来</p>
        <h2>登录账号</h2>
        <p class="form-hint">请输入注册时系统生成的 ECO 账号。</p>
        <label>
          账号
          <input
            v-model="identity"
            required
            autocomplete="username"
            placeholder="ECO-7F3K-9M2Q"
            maxlength="40"
          />
        </label>
        <label>
          密码
          <input
            v-model="password"
            required
            type="password"
            autocomplete="current-password"
            minlength="6"
            placeholder="输入你的密码"
          />
        </label>
        <p v-if="auth.error" class="form-error">{{ auth.error }}</p>
        <button class="primary-button" type="submit" :disabled="auth.loading">
          {{ auth.loading ? '正在登录…' : '进入学习空间' }}
        </button>
        <p class="auth-switch">
          第一次使用？
          <RouterLink to="/register">选择化名并注册</RouterLink>
        </p>
      </form>
    </section>
  </main>
</template>
